import { useEffect, useState } from 'react'
import { auth } from '../config/Firebase'
import { useAuthContext } from './useAuthContext'
import { signOut } from 'firebase/auth'
import { useUsers } from '../contexts/UsersContext'

export const useLogout = () => {
  const [isCancelled, setIsCancelled] = useState(false)
  const [error, setError] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const { dispatch } = useAuthContext()
  const { setLoggedOnUser } = useUsers()

  const logout = async () => {
    setError(null)
    setIsPending(true)

    try {
      // sign the user out
      await signOut(auth)

      // dispatch logout action
      dispatch({ type: 'LOGOUT' })
      setLoggedOnUser(null)
      // update state
      if (!isCancelled) {
        setIsPending(false)
        setError(null)
      }
    } catch (err) {
      if (!isCancelled) {
        setError(err.message)
        setIsPending(false)
      }
    }
  }

  useEffect(() => {
    return () => setIsCancelled(true)
  }, [])

  return { logout, error, isPending }
}
